import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import useSessionGuard from 'hooks/useSession';
import AuthLoader from 'components/AuthLoader';

// ==============================|| ROOT GUARD ||============================== //

export default function RootGuard({ children }) {
  const result = useSessionGuard();
  const navigate = useNavigate();

  const isAuthenticated = result.isLoggedIn ?? false;
  const isLoading = !(result.isInitialized ?? false);
  const isRoot = !!(result.user?.root);

  useEffect(() => {
    if (!isLoading && isAuthenticated && !isRoot) {
      navigate('/', {
        state: { accessDenied: true, message: 'Access denied. Root only.' },
        replace: true
      });
    }
  }, [isAuthenticated, isLoading, isRoot, navigate]);

  if (isLoading || (isAuthenticated && typeof result.user?.root === 'undefined')) {
    return <AuthLoader />;
  }

  if (!isAuthenticated || !isRoot) {
    return null;
  }

  return children;
}

RootGuard.propTypes = {
  children: PropTypes.any
};
